import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    error: '',
    isModalOpen: false,
    enachStatusDetails: null
};

const enachSlice = createSlice({
    name: 'enach',
    initialState,
    reducers: {
        setError: (state, action) => {
            state.error = action.payload;
        },
        openModal: (state) => {
            state.isModalOpen = true;
        },
        closeModal: (state) => {
            state.isModalOpen = false;
        },
        setEnachStatusDetails: (state, action) => {
            state.enachStatusDetails = action.payload;
        }
    }
});

export const {
    setError,
    openModal,
    closeModal,
    setEnachStatusDetails
} = enachSlice.actions;
export default enachSlice.reducer;
